import React from "react";

// TZ-9 п.4: человекочитаемый журнал «История изменений комиссий»
export const AUDIT_ACTION_LABELS = {
  update_rates: "Изменение ставок комиссии",
  create_promotion: "Создание акции",
  cancel_promotion: "Отмена акции",
  verify_executor: "Подтверждение исполнителя",
  revoke_executor: "Снятие статуса проверенного исполнителя",
  bulk_verify: "Массовое подтверждение исполнителей",
};

const FIELD_LABELS = {
  user_id: "ID пользователя", user_email: "Email", user_emails: "Пользователи", notes: "Комментарий",
  count: "Количество", promotion_id: "ID акции", name: "Название", rates: "Ставки", service_types: "Типы услуг",
  valid_from: "Действует с", valid_until: "Действует до", before: "Было", after: "Стало", rates_changed: "Изменённые ставки",
  general: "Общие услуги", secret_shopper: "Тайный покупатель", grave_care: "Мемориальный сервис",
  mobile_journalist: "Мобильный корреспондент", verified_executor_rate: "Ставка проверенного исполнителя",
  base_rates: "Базовые ставки", verified_executor_discount: "Скидка проверенному исполнителю",
  updated_at: "Обновлено", updated_by: "Кем изменено",
};

const RATE_KEYS = new Set(["general", "secret_shopper", "grave_care", "mobile_journalist"]);

const isEmpty = (v) => v === null || v === undefined || v === "" || (Array.isArray(v) && v.length === 0)
  || (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);

const shortId = (key, v) => (typeof v === "string" && /(^|_)id$/.test(key) && v.length > 6 ? `…${v.slice(-6)}` : v);

const formatScalar = (key, v) => {
  if (typeof v === "boolean") return v ? "да" : "нет";
  if (typeof v === "number" && v > 0 && v < 1 && (RATE_KEYS.has(key) || /rate|discount/.test(key))) return `${+(v * 100).toFixed(2)}%`;
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T/.test(v)) return new Date(v).toLocaleString("ru-RU");
  return String(shortId(key, v));
};

const DetailRows = ({ data, depth = 0 }) => (
  <ul className={depth ? "pl-3 border-l border-gray-200 mt-0.5" : ""}>
    {Object.entries(data).filter(([, v]) => !isEmpty(v)).map(([k, v]) => (
      <li key={k} className="leading-5">
        <span className="text-gray-500">{FIELD_LABELS[k] || k}:</span>{" "}
        {typeof v === "object" && !Array.isArray(v)
          ? <DetailRows data={v} depth={depth + 1} />
          : <span className="text-gray-800">{Array.isArray(v) ? v.map((x) => formatScalar(k, x)).join(", ") : formatScalar(k, v)}</span>}
      </li>
    ))}
  </ul>
);

export const CommissionAuditDetails = ({ details }) => {
  if (!details || typeof details !== "object" || isEmpty(details)) return <span className="text-gray-400">—</span>;
  return <div className="text-xs break-words" data-testid="audit-log-details"><DetailRows data={details} /></div>;
};
